'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherRotateCcw } from '@subframe/core';
import { useEffect, useState } from 'react';
import { Button, Dialog, TextArea } from '@/shared/components/ui';
import type { Apuracao } from '../types';
import { formatarDataCurta, formatarMoedaBR } from '../utils/apuracaoFormatters';
interface ReabrirCicloModalProps {
  isOpen: boolean;
  apuracao: Apuracao | null;
  saving: boolean;
  onClose: () => void;
  onConfirm: (justificativa: string) => void;
}
const MIN_JUSTIFICATIVA = 20;
export function ReabrirCicloModal(t0) {
  const $ = _c(71);
  const {
    isOpen,
    apuracao,
    saving,
    onClose,
    onConfirm
  } = t0;
  const [justificativa, setJustificativa] = useState("");
  const [ciente, setCiente] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isOpen) {
    t1 = () => {
      if (isOpen) {
        setJustificativa("");
        setCiente(false);
      }
    };
    t2 = [isOpen];
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!apuracao) {
    return null;
  }
  let t3;
  if ($[3] !== justificativa) {
    t3 = justificativa.trim();
    $[3] = justificativa;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const justificativaValida = t3.length >= MIN_JUSTIFICATIVA;
  const podeConfirmar = justificativaValida && ciente && !saving;
  let t4;
  if ($[5] !== justificativa) {
    t4 = justificativa.trim();
    $[5] = justificativa;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const caracteresFaltantes = Math.max(0, MIN_JUSTIFICATIVA - t4.length);
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bg-warning-50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"><FeatherRotateCcw className="text-warning-600 h-5 w-5" /></div>;
    t6 = <h2 className="text-body-bold font-body-bold text-default-font">Reabrir ciclo</h2>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== apuracao.fechadoEm) {
    t7 = apuracao.fechadoEm ? formatarDataCurta(apuracao.fechadoEm) : "\u2014";
    $[9] = apuracao.fechadoEm;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== apuracao.tenantNome || $[12] !== t7) {
    t8 = <div className="flex items-start gap-3">{t5}<div>{t6}<p className="text-caption font-caption text-subtext-color mt-1">{apuracao.tenantNome} · fechado em{" "}{t7}</p></div></div>;
    $[11] = apuracao.tenantNome;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== apuracao.faturaEmitida) {
    t9 = apuracao.faturaEmitida && <div className="border-error-200 bg-error-50 flex items-start gap-3 rounded-[8px] border px-4 py-3 text-sm"><FeatherAlertTriangle className="text-error-600 mt-0.5 h-4 w-4 shrink-0" /><div><p className="text-error-700 font-semibold">Fatura emitida será cancelada automaticamente</p><p className="text-error-700 mt-0.5">Ao reabrir, a fatura vinculada será cancelada e a cobrança no Asaas será encerrada. Após fechar o ciclo novamente, será necessário gerar uma nova fatura.</p></div></div>;
    $[14] = apuracao.faturaEmitida;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="text-caption font-caption text-subtext-color">Total fechado</p>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== apuracao.totalCobravel) {
    t11 = formatarMoedaBR(apuracao.totalCobravel);
    $[17] = apuracao.totalCobravel;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <div>{t10}<p className="text-body-bold font-body-bold text-default-font mt-1">{t11}</p></div>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p className="text-caption font-caption text-subtext-color">Eventos</p>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== apuracao.totalEventos) {
    t14 = <div>{t13}<p className="text-body-bold font-body-bold text-default-font mt-1">{apuracao.totalEventos}</p></div>;
    $[22] = apuracao.totalEventos;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t12 || $[25] !== t14) {
    t15 = <div className="grid grid-cols-2 gap-3 rounded-[12px] bg-neutral-50 p-4">{t12}{t14}</div>;
    $[24] = t12;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <label className="text-sm font-medium text-neutral-700">Justificativa da reabertura *</label>;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = e => setJustificativa(e.target.value);
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== justificativa) {
    t18 = <TextArea><TextArea.Input placeholder={"Descreva o motivo da reabertura. Esta justificativa ser\xE1 registrada na auditoria e vis\xEDvel para os envolvidos."} value={justificativa} onChange={t17} rows={4} /></TextArea>;
    $[29] = justificativa;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== caracteresFaltantes || $[32] !== justificativa) {
    t19 = caracteresFaltantes > 0 ? `Faltam ${caracteresFaltantes} ${caracteresFaltantes === 1 ? "caractere" : "caracteres"} (mínimo ${MIN_JUSTIFICATIVA})` : `${justificativa.trim().length} caracteres`;
    $[31] = caracteresFaltantes;
    $[32] = justificativa;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t19) {
    t20 = <p className="text-caption font-caption text-subtext-color">{t19}</p>;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t18 || $[37] !== t20) {
    t21 = <div className="flex flex-col gap-1.5">{t16}{t18}{t20}</div>;
    $[36] = t18;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = e_0 => setCiente(e_0.target.checked);
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== ciente) {
    t23 = <input type="checkbox" checked={ciente} onChange={t22} className="accent-warning-600 mt-0.5 h-4 w-4 rounded border-neutral-300" />;
    $[40] = ciente;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <span className="text-sm text-neutral-700">Confirmo que esta reabertura é necessária e estou ciente do impacto</span>;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t23) {
    t25 = <label className="flex cursor-pointer items-start gap-3">{t23}{t24}</label>;
    $[43] = t23;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="flex items-start gap-2 rounded-[8px] bg-neutral-50 px-3 py-2 text-xs text-neutral-600">Após a reabertura, o ciclo volta para o status{" "}<span className="font-semibold">Reaberto</span>, permite reprocessamento de eventos e mantém marcação visível no histórico.</div>;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== onClose || $[47] !== saving) {
    t27 = <Button variant="neutral-secondary" size="medium" onClick={onClose} disabled={saving}>Cancelar</Button>;
    $[46] = onClose;
    $[47] = saving;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <FeatherRotateCcw />;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== justificativa || $[51] !== onConfirm) {
    t29 = () => onConfirm(justificativa.trim());
    $[50] = justificativa;
    $[51] = onConfirm;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  const t30 = !podeConfirmar;
  let t31;
  if ($[53] !== saving || $[54] !== t29 || $[55] !== t30) {
    t31 = <Button variant="destructive-primary" size="medium" icon={t28} onClick={t29} loading={saving} disabled={t30}>Reabrir ciclo</Button>;
    $[53] = saving;
    $[54] = t29;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== t27 || $[58] !== t31) {
    t32 = <div className="flex items-center justify-end gap-2 border-t border-neutral-100 pt-4">{t27}{t31}</div>;
    $[57] = t27;
    $[58] = t31;
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== t15 || $[61] !== t21 || $[62] !== t25 || $[63] !== t32 || $[64] !== t8 || $[65] !== t9) {
    t33 = <Dialog.Content className="max-w-lg"><div className="flex w-full flex-col gap-5 p-6">{t8}{t9}{t15}{t21}{t25}{t26}{t32}</div></Dialog.Content>;
    $[60] = t15;
    $[61] = t21;
    $[62] = t25;
    $[63] = t32;
    $[64] = t8;
    $[65] = t9;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] !== isOpen || $[68] !== onClose || $[69] !== t33) {
    t34 = <Dialog open={isOpen} onOpenChange={onClose}>{t33}</Dialog>;
    $[67] = isOpen;
    $[68] = onClose;
    $[69] = t33;
    $[70] = t34;
  } else {
    t34 = $[70];
  }
  return t34;
}